export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70442e0d48d60c843a844470654d1f1919ebbd8df5&name=pushAdClickData!'